import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/frontend/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/frontend/markdoc/tags.js'
import * as nodes from '/vercel/path0/frontend/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Zestawy Kodów\ndescription: Jak zdobyć i jak używać kodów do katalogowania.\n---\n\n## Skąd wziąć kody / etykiety QR?\n\n### Samodzielne przygotowanie lub zakup\n\nKażdy użytkownik posiada możliwość wygenerowania kodów w Bibliodesku.  Wygenerowane kody po wydrukowaniu są gotowe do połączenia z egzemplarzem książki. Możesz też [kupić u nas gotowe naklejki](https://www.youtalky.com/contact), które wydrukowane są na etykietach samoprzylepnych Emerson ([dostępne w sklepach](https://allegro.pl/listing?string=emerson%20etykiety&order=p))\n\n### Jak dodać egzemplarz własnej książki na półkę?\n\nAby przyporządkować książkę do półki i umożliwić jej odnalezienie, wymianę z innymi użytkownikami lub dodać do niej nagranie głosowe, należy dodać do niej etykietę z kodem QR a następnie zeskanować go.\n\nZeskanowanie kodu QR otworzy moduł wiązania informacji o książce z naklejonym kodem.\nDodawanie egzemplarza odbywa się automatycznie i wymaga jedynie wpisania kodu ISBN - sprawdź jak wygląda taki proces na poniższym filmiku.\n\n{% iframe src=\"https://www.youtube.com/embed/R6zthnz9t-4\" %} {% /iframe %}\n\n### Wydrukuj Samodzielnie\n\nMożesz też wydrukować kody samodzielnie. Aby to zrobić:\n\n1. Wejdź do **Bibliodesk**u.\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-01.jpg)\n\n2. Wejdź do zakładki **Etykiety**\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-02.jpg)\n\n3. Wybierz szablon, który Cię interesuje\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-03.jpg)\n\n4. Kliknij **Generuj**\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-04.jpg)\n\n{% callout type=\"info\" title=\"Wiedz, że...\" %}\nzawsze możesz zwiększyć limit kodów [kontaktując się z nami](https://www.youtalky.com/contact).\n{% /callout %}\n\n5. Plik PDF po chwili ściągnie się na Twój dysk\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-05.jpg)\n\n6. Po otwarciu, kody można wydrukować.\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-06.jpg)\n\n{% callout type=\"warning\" title=\"Pamiętaj, że...\" %}\n\nkażdy [kod QR](https://geex.x-kom.pl/lifestyle/co-to-jest-kod-qr-do-czego-sluzy/) jest unikalny i może być powiązany z informacjami o książce tylko raz. Usuń plik PDF po wydrukowaniu, aby nie wydrukować go przez pomyłkę dwukrotnie.\n\n{% /callout %}\n\n### Przykłady wydrukowanych kodów\n\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-etykiety-01.jpg)\n\n![Kody do katalogowania](/imgs/docs/generate/bibliodesk-generowanie-kodow-etykiety-02.jpg)\n";
const filepath = "/docs/katalogowanie-etykiety-zestawy-kodow-kreskowych.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
